// Tenantra Inc. - Shared data load for the landlord Home widgets (cached briefly so widgets share one fetch)
import api from '@/services/api';

let cache = null;
const empty = { data: { items: [] } };

export const loadHomeData = () => {
  if (cache && Date.now() - cache.at < 15000) return cache.promise;
  const promise = Promise.all([
    api.get('/properties?limit=500'),
    api.get('/tenancies?limit=500'),
    api.get(`/reports?period=${lastMonthStart()}&limit=500`).catch(() => empty),
    api.get('/disputes').catch(() => empty),
  ]).then(([p, t, r, d]) => ({
    props: p.data.items || [], tenancies: t.data.items || [], reports: r.data.items || [], disputes: d.data.items || [],
  }));
  cache = { at: Date.now(), promise };
  promise.catch(() => { cache = null; });
  return promise;
};

export const lastMonthStart = () => {
  const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};

export const monthLabel = (iso, month = 'long') => {
  const [y, m] = iso.split('-');
  return new Date(y, m - 1, 1).toLocaleDateString('en-CA', { month, year: 'numeric' });
};
